import { CodeIcon, Lock, LogOut, MonitorCog, Moon, Sun, Unlock } from 'lucide-react';

import { NavItem } from '@crossnokaye/ux-common';

import { useTheme } from '@/providers/theme-provider';

export const AccessSelectorContent = ({
  isViewOnly,
  handleToggleActive,
  handleSignOut,
}: {
  isViewOnly: boolean;
  handleToggleActive: () => void;
  handleSignOut: () => void;
}) => {
  const { theme, setTheme } = useTheme();

  const handleManageTokens = () => {
    const currentHost = window.location.hostname;
    const newHost = currentHost.replace('go.', 'login.');

    window.location.href = `https://${newHost}/admin/tokens`;
  };

  const handleThemeToggle = () => {
    if (theme === 'light') {
      setTheme('dark');
    } else if (theme === 'dark') {
      setTheme('system');
    } else {
      setTheme('light');
    }
  };

  const getThemeLabel = () => {
    if (theme === 'light') return 'Use Dark Mode';
    if (theme === 'dark') return 'Use System Mode';
    return 'Use Light Mode';
  };

  const getThemeIcon = () => {
    if (theme === 'light') return <Moon className="glyph glyph-sm" aria-hidden="true" />;
    if (theme === 'dark') return <MonitorCog className="glyph glyph-sm" aria-hidden="true" />;
    return <Sun className="glyph glyph-sm" aria-hidden="true" />;
  };
  return (
    <>
      <NavItem
        id={'read-only-toggle'}
        data-testid={'read-only-toggle'}
        label={isViewOnly ? 'Switch to Active' : 'Switch to View Only'}
        icon={
          isViewOnly ? (
            <Unlock className="glyph glyph-sm" aria-hidden="true" />
          ) : (
            <Lock className="glyph glyph-sm" aria-hidden="true" />
          )
        }
        className={'hover:bg-tertiary p-2'}
        onClick={handleToggleActive}
      />
      <NavItem
        id={'manage-refresh-tokens'}
        data-testid={'manage-refresh-tokens'}
        label={'Manage API Tokens'}
        icon={<CodeIcon className="glyph glyph-sm" aria-hidden="true" />}
        className={'hover:bg-tertiary p-2'}
        onClick={handleManageTokens}
      />
      <NavItem
        id={'theme-toggle'}
        data-testid={'theme-toggle'}
        label={getThemeLabel()}
        icon={getThemeIcon()}
        className={'hover:bg-tertiary p-2'}
        onClick={handleThemeToggle}
      />
      <NavItem
        id={'log-out'}
        data-testid={'log-out'}
        label={'Sign Out'}
        icon={<LogOut className="glyph glyph-sm" aria-hidden="true" />}
        onClick={handleSignOut}
        className={'hover:bg-tertiary p-2'}
      />
    </>
  );
};
